import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../../../utils/api";
import DashboardHeader from "./widgets/DashboardHeader";
import UserInfoTab from "./tabs/UserInfoTabs";
import ReviewsTab from "./tabs/ReviewTabs";

const AdminDashboard = ({ user }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("reviews");

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("api/dashboard/admin");
        if (res.ok) setDashboardData(res.data);
        else toast.error("Failed to load dashboard data");
      } catch (e) {
        console.error(e);
        toast.error("An error occurred while loading dashboard");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"50vh",fontSize:18,color:"#6b7280"}}>
        <span className="loading-spinner" /> Loading dashboard...
      </div>
    );
  }

  return (
    <div>
      <DashboardHeader user={user} />

      <div style={{ marginBottom: 16 }}>
        <button
          onClick={() => setActiveTab("userInfo")}
          className={`btn ${activeTab === "userInfo" ? "btn-primary" : "btn-secondary"}`}
          style={{ marginRight: 8 }}
          role="tab"
          aria-selected={activeTab === "userInfo"}
        >
          User Info
        </button>
        <button
          onClick={() => setActiveTab("reviews")}
          className={`btn ${activeTab === "reviews" ? "btn-primary" : "btn-secondary"}`}
          role="tab"
          aria-selected={activeTab === "reviews"}
        >
          Review & Scores
        </button>
      </div>

      {/* Animated panel: re-mounts on tab change via the key */}
      <div className="tab-content">
        <div key={activeTab} className="tab-panel animate-slide-up">
          {activeTab === "userInfo" && dashboardData ? (
            <UserInfoTab data={dashboardData} />
          ) : (
            <ReviewsTab />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
